import React, {useContext} from 'react';
import './CSS/ShopCategory.css';
import {ShopContext} from "../context/ShopContext";
import Item from "../components/Item/Item";
import Description_ShopCategory from '../components/Assets/Description_ShopCategory';
import Baner from '../components/Baner/Baner';

const ShopCategory = (props) => {
    const {all_product} = useContext(ShopContext);
    const categoryData = Description_ShopCategory.find(item => item.category === props.category);


    return (
        <section className='shop-category'>
            <div className='content-wrap'>
                <div className='baner-shop-category'>
                    {categoryData && (
                        <Baner image={categoryData.images} description={categoryData.description}/>
                    )}
                </div>

                <div className='shopcategory-products'>
                    {all_product.map((item, i) => {
                        if (props.category === item.category) {
                            return <Item key={i} id={item.id} name={item.name} image={item.images?.[0]}
                                         new_price={item.new_price} old_price={item.old_price}
                                         description={item.description} category={item.category}/>
                        } else {
                            return null;
                        }
                    })}
                </div>
            </div>
        </section>
    )
}

export default ShopCategory;
//
// const ShopCategory = (props) => {
//     const {all_product, Description_ShopCategory} = useContext(ShopContext);
//
//
//     return (
//         <section className='shop-category'>
//             <div className='baner-shop-category'>
//                 {Description_ShopCategory.map((item, i) => {
//                     if (props.category === item.category) {
//                         return <Item key={i} image={item.images} description={item.description} category={item.category}/>
//                     } else {
//                         return null;
//                     }
//                 })}</div>
//
//             <div className='content-wrap'>
//                 <div className='shopcategory-products'>
//                     {all_product.map((item, i) => {
//                         if (props.category === item.category) {
//                             return <Item key={i} id={item.id} name={item.name} image={item.images?.[0]} new_price={item.new_price} old_price={item.old_price} description={item.description} category={item.category}/>
//                         } else {
//                             return null;
//                         }
//                     })}
//                 </div>
//             </div>
//         </section>
//     )
// }
//
// export default ShopCategory;